import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers, { history } from "../../reducer";
import { connectRouter, routerMiddleware } from "connected-react-router";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  connectRouter(history)(reducers),
  {},
  composeEnhancers(applyMiddleware(routerMiddleware(history), thunk))
);

export default store;
